import { decodeErrorResult, Hex } from 'viem';

import { ERROR_MESSAGES, GAS_LIMIT_TOO_HIGH_MESS } from '@/app/shared/constants/errors';
import { ABI_ERROR } from '@/app/shared/constants/web3/constants';

type ErrorMessageKey = keyof typeof ERROR_MESSAGES;

const ABI_ERROR_DATA_RE = /0x[a-fA-F0-9]{8,}/;

export const handleContractsError = (error: string, defaultErrorMessage: string): string => {
  if (!error) return defaultErrorMessage;

  if (/gas limit too high/i.test(error)) {
    return GAS_LIMIT_TOO_HIGH_MESS;
  }

  const dataMatch = error.match(ABI_ERROR_DATA_RE);
  if (!dataMatch) {
    return error.trim() || defaultErrorMessage;
  }

  try {
    const { errorName } = decodeErrorResult({
      abi: ABI_ERROR,
      data: dataMatch[0] as Hex,
    });

    if (!errorName) return defaultErrorMessage;

    return ERROR_MESSAGES[errorName as ErrorMessageKey] ?? defaultErrorMessage;
  } catch {
    return error.trim() || defaultErrorMessage;
  }
};
